export default {"src":"/_next/static/media/satisfaction-user-happy-icon.64521c36.svg","height":15,"width":14};